export interface OrdersBasketWorkspaceMetaState {
  workspaceTabsFetched: boolean;
  workspaceTabContentAllFetched: boolean;
}

export const initialOrdersBasketWorkspaceMetaState: OrdersBasketWorkspaceMetaState = {
  workspaceTabsFetched: false,
  workspaceTabContentAllFetched: false,
};
